import React, { useContext, useState } from "react"
import { Button, Modal as ModalStrap, Container, ModalBody, ModalFooter } from 'reactstrap';

const AlertStateContext = React.createContext(false);
const useAlert = () => {
    return useContext(AlertStateContext);
}

// create and export the AuthProvider - this is imported to the _app.js file
// and wrapped around the whole app, providing context to the whole app, and
// is called each time this specific context is accessed (updated or retrieved)
const AlertProvider = ({ children }) => {
    const [state, dispatch] = useState();
    const onCloseAlert = (state) => {
        dispatch();
        state && state.onDismiss && state.onDismiss();       
    }
    return (<AlertStateContext.Provider value={dispatch}>
             <ModalStrap isOpen={state?true:false}  size={ !(state&&state.modalSize)?"lg":state.modalSize}>
                <Container style={{ backgroundColor: 'lightblue' }}>{state?.title?state.title:'Alert!'}</Container>
                <ModalBody>
                    {state?.body}
                </ModalBody>
                <ModalFooter>
                    {state?.buttons ? state.buttons : <Button color="secondary" onClick={()=>onCloseAlert(state)}>OK</Button>}
                </ModalFooter>
            </ModalStrap>
            {children}
        </AlertStateContext.Provider>)
};

export { AlertProvider, useAlert };